module.exports = __webpack_public_path__ + "img/chess.a3a88e56.jpg";